import {RaEvent, RaEventType} from "./RaEvent";

export enum RECORDING_STATUS {
    start = 0,
    stop = 1
}

export class RecordingStatusEvent extends RaEvent {
    static TYPE:RaEventType = "read_status_event";
    constructor(private _status:RECORDING_STATUS) {
        super(RecordingStatusEvent.TYPE);
    }

    public get status():RECORDING_STATUS {
        return this._status;
    }
}

export class ReadSelectionEvent extends RaEvent {
    static TYPE:RaEventType = "read_selection_event";
    constructor() {
        super(ReadSelectionEvent.TYPE);
    }
}

export class RecordSelectionEvent extends RaEvent {
    static TYPE:RaEventType = "record_selection_event";
    constructor() {
        super(RecordSelectionEvent.TYPE);
    }
}

export class PauseSelectionEvent extends RaEvent {
    static TYPE:RaEventType = "pause_selection_event";
    constructor() {
        super(PauseSelectionEvent.TYPE);
    }
}

export class NextSentenceEvent extends RaEvent {
    static TYPE:RaEventType = "next_sentence_event";
    constructor() {
        super(NextSentenceEvent.TYPE);
    }
}

export class PlayRecordingEvent extends RaEvent {
    static TYPE:RaEventType = "play_recording_event";
    constructor() {
        super(PlayRecordingEvent.TYPE);
    }
}

export class ReadMyRecordingEvent extends RaEvent {
    static TYPE:RaEventType = "read_my_recording_event";
    constructor() {
        super(ReadMyRecordingEvent.TYPE);
    }
}

export class CountdownStartEvent extends RaEvent {
    static TYPE:RaEventType = "countdown_start_event";
    constructor() {
        super(CountdownStartEvent.TYPE);
    }
}

export class CountdownStopEvent extends RaEvent {
    static TYPE:RaEventType = "countdown_stop_event";
    constructor() {
        super(CountdownStopEvent.TYPE);
    }
}
